import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { format } from 'date-fns';
import LogoPDFSVG from './LogoPDFSVG';
import LogoMarkPDFSVG from './LogoMarkPDFSVG';
import { CustomerState } from '../../../../redux/customer';
import { ChildCustomerState } from '../../../../redux/childCustomer';

const COMPLIANCE_BLUE = '#0084b7';
const HEALTHFIRST_PHONE_NUMBER = '941-587-2864';
const DATE_FORMAT = 'MM/dd/yyyy';

const styles = StyleSheet.create({
  centeredMiddle: {
    flex: 2,
    textAlign: 'center'
  },
  flexItem: {
    flex: 1
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0.25in'
  },
  healthFirstContact: {
    fontWeight: 'bold',
    fontSize: '14pt',
    color: COMPLIANCE_BLUE
  },
  page: {
    fontFamily: 'Open Sans',
    fontSize: '10pt'
  },
  pageHeading: {
    fontWeight: 'bold',
    fontSize: '20pt'
  },
  pageNumber: {
    fontWeight: 'bold'
  },
  practiceInfo: {
    fontWeight: 'bold'
  },
  footerFixed: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    paddingTop: '8pt'
  },
  footerRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '0.25in',
    marginRight: '0.25in',
    marginBottom: '0.2in'
  }
});

interface HeaderProps {
  customer: CustomerState | ChildCustomerState;
  title: string;
  year: string;
}

export const Header = ({ customer, title, year }: HeaderProps) => (
  <View fixed style={[styles.flexRow, styles.page]}>
    <View style={[styles.flexItem, styles.practiceInfo]}>
      <Text>{customer.name}</Text>
      <Text>{customer.doctor_name}</Text>
      <Text>{customer.street ?? ''}</Text>
      <Text>{customer.street2 ?? ''}</Text>
      <Text>
        {customer.city ?? ''}, {customer.state ?? ''} {customer.zip ?? ''}
      </Text>
    </View>
    <View style={styles.centeredMiddle}>
      <Text style={styles.pageHeading}>
        {year} {title}
      </Text>
      <Text>Report generated: {format(new Date(), DATE_FORMAT)}</Text>
    </View>
    <View style={styles.flexItem}>
      <LogoPDFSVG />
    </View>
  </View>
);

export const Footer = () => (
  <View fixed style={styles.footerFixed}>
    <View style={styles.footerRow}>
      <View style={[styles.flexItem, { display: 'flex', flexDirection: 'row', alignItems: 'center' }]}>
        <LogoMarkPDFSVG width={30} style={{ margin: '10pt 10pt 10pt 0' }} />
        <View style={{ fontWeight: 'bold' }}>
          <Text>Generated By OnTraq</Text>
          <Text>HealthFirst.com/OnTraq</Text>
        </View>
      </View>
      <View style={styles.centeredMiddle}>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
      </View>
      <View style={[styles.flexItem, styles.healthFirstContact, { textAlign: 'right' }]}>
        <Text style={{ letterSpacing: 2 }}>{HEALTHFIRST_PHONE_NUMBER}</Text>
        <Text>Healthfirst.com</Text>
      </View>
    </View>
  </View>
);